import { SenhaPrimeiroAcessoComponent } from './../senha-primeiro-acesso/senha-primeiro-acesso.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { VerificarPermissoes } from './../model/verificarPermissoes.model';
import { AuthService } from './../service/auth.service';
import { Router } from '@angular/router';
import { AccountService } from './../service/account.service';
import { Component, OnInit } from '@angular/core';
import { UsuariosService } from '../service/usuarios.service';
import Swal from 'sweetalert2';
import { AlertaTempoSessaoService } from '../service/alerta-tempo-sessao.service';
import { ContratosService } from '../service/contratos.service';
import { DialogComponent } from './dialog/dialog.component';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  usuarioId!: any
  token!: any
  aviso: boolean = false;
  permissao = [] as any;
  verificaSeMostraCardSemProdutos: any = 1
  load = true;
  urlPremoplan = environment.baseUrlPremoplan;
  urlHidrometer = environment.baseUrlHidrometer;
  baseUrlHidrometerV3 = environment.baseUrlHidrometerV3;
  urlTopes = environment.baseUrlTopes;
  urlCronosDashboard = environment.baseUrlCronosDashboard;
  urlPremovin = environment.baseUrlPremovin;
  produtos: any[] = [];

  constructor(private serviceAccount: AccountService,
    private router: Router,
    private usuarioService: UsuariosService,
    private contratoService: ContratosService,
    private authService: AuthService,
    private alertaSessao: AlertaTempoSessaoService,
    public dialog: MatDialog,
  ) { }


  ngOnInit() {
    this.token = localStorage.getItem('token')

    this.produtos = [
      {
        nome: 'Hidrometer',
        classe: 'hidrometer',
        logo: '../../assets/logo-hidrometer-completa.png',
        descricao: 'Solução completa para automação da irrigação e fertirrigação',
        permissoes: ['acessar_hidrometer'],
        acao: () => this.Hidrometer()
      },
      {
        nome: 'Premoplan',
        classe: 'premoplan',
        logo: '../../assets/logo-promoplan-hori.png',
        descricao: 'Solução completa para automação do plantio mecanizado de cana picada',
        permissoes: ['acessar'],
        acao: () => this.premoplan()
      },
      {
        nome: 'Premovin',
        classe: 'premovin',
        logo: '../../assets/logo-premovin.png',
        descricao: 'Solução para automação e gerenciamento da aplicação de vinhaça localizada.',
        permissoes: ['access_premovin'],
        acao: () => this.premovin()
      },
      {
        nome: 'Topes',
        classe: 'topes',
        logo: '../../assets/logo-topes-hori.png',
        descricao: 'Solução para automação de transbordo e mapa de produtividade.',
        permissoes: ['acessar_topes'],
        acao: () => this.topes()
      },
      {
        nome: 'Cronos Dashboard',
        classe: 'cronosDashboard',
        logo: '../../assets/logo-cronos-dashboard-hori.svg',
        descricao: 'Gerenciamento e controle de comunicadores, contratos e financeiro.',
        permissoes: ['access_cronos_dashboard'],
        acao: () => this.cronosDashboard()
      }
    ];

    this.VerificarAutenticacao();
    this.verificaContrato();
    this.usuarioService.listarPorIdService(localStorage.getItem('usuarioId')).subscribe((usuario: any) => {
      if (usuario.bl_primeiro_acesso == 1) {
        const dialogRef = this.dialog.open(SenhaPrimeiroAcessoComponent, { disableClose: true })
      }
    })
  }

  verificaContrato() {
    this.contratoService.produtosVerificacao().subscribe(
      (resp: any) => {
        this.permissao = resp
        if (this.permissao.length == 0) {
          this.verificaSeMostraCardSemProdutos = 0
        }
        this.load = false
      })
    this.contratoService.contratosExpirar(localStorage.getItem('usuarioId')).subscribe(
      (resp: any) => {
        if (resp.status == undefined) {
          const dialogRef = this.dialog.open(DialogComponent, {
            width: '40vw',
            data: resp,
            disableClose: true
          });
        } else if (resp.status == "Há contratos prestes a vencer") {
          this.aviso = true;
          setTimeout(() => { this.aviso = false; }, 10000);
        }
      })
  }

  fecharAviso() {
    this.aviso = false;
  }

  async redefinirSenha() {
    const ipAPI = '//api.ipify.org?format=json'

    const inputValue = fetch(ipAPI).then(response => response.json()).then(data => data.ip)

    const { value: senha } = await Swal.fire({
      title: 'Seja bem-vindo ao PremoCenter!',
      inputValue: inputValue,
      inputLabel: 'É necessário que a senha contenha pelo menos 6 caracteres',
      inputAttributes: {
        minlength: "6",
        autocapitalize: 'off',
        autocorrect: 'off'
      },
      text: "Como é seu primeiro acesso a nossa plataforma é necessário definir uma nova senha.",
      inputPlaceholder: 'Nova senha',
      width: "40rem",
      allowOutsideClick: false
    })
    if (senha.length >= 6) {
      var usuario = {
        "vc_senha": senha,
      }
      this.usuarioService.atualizarSenha(usuario, localStorage.getItem('usuarioId')).subscribe((senha: any) => {
        Swal.fire({
          icon: 'success',
          title: 'Senha alterada com sucesso',
        })
      }, (err) => {
        this.redefinirSenha();
      })
    } else {
      this.redefinirSenha();
    }
  }

  sair() {
    this.serviceAccount.sairService().subscribe(resp => {
      window.localStorage.removeItem('token');
      this.router.navigate(['/login']);
      this.alertaSessao.cancelar()
    }, err => {
      this.router.navigate(['/login']);
    })
  }

  VerificarAutenticacao() {
    this.authService.Autenticar(this.token).subscribe((autenticacao: any) => {
      var finalSessao = autenticacao.resposta[0].ts_vencimento
      this.alertaSessao.alertaSessaoService()
    }
      , err => {
        if (err == '401') {
          localStorage.removeItem('token')
          this.router.navigate(['/login'])
        }
      }
    )
  }

  Hidrometer() {
    window.location.href = `${this.baseUrlHidrometerV3}/${this.token}`;
  }

  premoplan() {
    window.location.href = `${this.urlPremoplan}/${this.token}`;
  }

  whatsapp() {
    window.location.href = "https://api.whatsapp.com/send?phone=5517997337556";
  }

  public verificarPermissao(permissoesFuncionalidades: string[]): boolean {
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }

  topes() {
    window.location.href = `${this.urlTopes}/${this.token}`;
  }

  cronosDashboard() {
    window.location.href = `${this.urlCronosDashboard}/${this.token}`;
  }

  premovin() {
    window.location.href = `${this.urlPremovin}/${this.token}`;
  }

  get produtosDisponiveis() {
    return this.produtos.filter(produto =>
      this.verificarPermissao(produto.permissoes) &&
      this.permissao.includes(produto.nome)
    );
  }
}
